function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useController } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl, FormLabel, Grid, TextField, Tooltip } from '@mui/material';
import { useHookFieldError } from '../../hooks';
import { CustomFieldLayoutType, defaultCustomFieldHorizontalLayout, defaultCustomFieldVerticalLayout } from '../../models';
export var TextHookField = function(_param) {
    var name = _param.name, control = _param.control, InputLabelProps = _param.InputLabelProps, _param_fullWidth = _param.fullWidth, fullWidth = _param_fullWidth === void 0 ? true : _param_fullWidth, _param_allowOnlyDigits = _param.allowOnlyDigits, allowOnlyDigits = _param_allowOnlyDigits === void 0 ? false : _param_allowOnlyDigits, _param_allowCharOnly = _param.allowCharOnly, allowCharOnly = _param_allowCharOnly === void 0 ? false : _param_allowCharOnly, _param_maxDecimalPlaces = _param.maxDecimalPlaces, maxDecimalPlaces = _param_maxDecimalPlaces === void 0 ? 0 : _param_maxDecimalPlaces, _param_digitCount = _param.digitCount, digitCount = _param_digitCount === void 0 ? 0 : _param_digitCount, helperText = _param.helperText, defaultValue = _param.defaultValue, _param_charCount = _param.charCount, charCount = _param_charCount === void 0 ? 1000 : _param_charCount, displayValue = _param.displayValue, label = _param.label, disabled = _param.disabled, _param_customLabel = _param.customLabel, customLabel = _param_customLabel === void 0 ? true : _param_customLabel, _param_customFieldLayout = _param.customFieldLayout, customFieldLayout = _param_customFieldLayout === void 0 ? defaultCustomFieldVerticalLayout : _param_customFieldLayout, restProps = _object_without_properties(_param, [
        "name",
        "control",
        "InputLabelProps",
        "fullWidth",
        "allowOnlyDigits",
        "allowCharOnly",
        "maxDecimalPlaces",
        "digitCount",
        "helperText",
        "defaultValue",
        "charCount",
        "displayValue",
        "label",
        "disabled",
        "customLabel",
        "customFieldLayout"
    ]);
    var t = useTranslation().t;
    var _useController = useController({
        name: name,
        control: control,
        defaultValue: defaultValue
    }), _useController_field = _useController.field, ref = _useController_field.ref, onChange = _useController_field.onChange, onBlur = _useController_field.onBlur, value = _useController_field.value, fieldState = _useController.fieldState, restField = _object_without_properties(_useController.field, [
        "ref",
        "onChange",
        "onBlur",
        "value"
    ]);
    var inputTextRef = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isTooltipVisible = _useState[0], setIsTooltipVisible = _useState[1];
    var errorText = useHookFieldError(fieldState, label);
    var errText = useMemo(function() {
        if (errorText) return errorText;
        if (restProps.multiline && (value === null || value === void 0 ? void 0 : value.length) > charCount) {
            return t('common.form.errors.maxError', {
                count: charCount
            });
        }
        return '';
    }, [
        errorText,
        restProps.multiline,
        value === null || value === void 0 ? void 0 : value.length,
        charCount,
        t
    ]);
    var handleChange = useCallback(function(e) {
        var targetValue = '';
        if (allowOnlyDigits) {
            targetValue = String(e.target.value).replace(/\D/g, '');
        } else if (allowCharOnly) {
            targetValue = e.target.value.replace(/\d/g, '');
        } else {
            targetValue = e.target.value;
        }
        if (restProps.onChange) {
            restProps.onChange(e);
        }
        if (targetValue && maxDecimalPlaces) {
            var pattern = new RegExp("^\\d+(\\.\\d{0,".concat(maxDecimalPlaces, "})?$"));
            return pattern.test(targetValue) ? onChange(targetValue !== null && targetValue !== void 0 ? targetValue : null) : null;
        }
        if (targetValue && digitCount) {
            var pattern1 = new RegExp("^\\d{0,".concat(digitCount, "}$"));
            return pattern1.test(targetValue) ? onChange(targetValue !== null && targetValue !== void 0 ? targetValue : null) : null;
        }
        if (restProps.type === 'number') {
            return onChange(targetValue || null);
        }
        return onChange(targetValue);
    }, [
        allowOnlyDigits,
        allowCharOnly,
        restProps,
        maxDecimalPlaces,
        digitCount,
        onChange
    ]);
    var handleBlur = useCallback(function(e) {
        var _restProps_onBlur;
        if (value && restProps.type !== 'number') {
            onChange(value === null || value === void 0 ? void 0 : value.trim());
        }
        onBlur();
        (_restProps_onBlur = restProps.onBlur) === null || _restProps_onBlur === void 0 ? void 0 : _restProps_onBlur.call(restProps, e);
    }, [
        onBlur,
        onChange,
        restProps,
        value
    ]);
    var handleWheel = useCallback(function(e) {
        var target = e.target;
        if (target.type === 'number') {
            target.blur();
        }
    }, []);
    useEffect(function() {
        var text = inputTextRef.current;
        if (text) {
            var isOverflowing = text.scrollWidth > text.offsetWidth;
            setIsTooltipVisible(isOverflowing);
        }
    }, [
        value
    ]);
    var isHorizontalLayout = label ? customFieldLayout.mode === CustomFieldLayoutType.horizontal : false;
    var _customFieldLayout_labelCol, _customFieldLayout_inputCol, _ref;
    return /*#__PURE__*/ _jsx(FormControl, {
        disabled: disabled,
        required: restProps.required,
        fullWidth: fullWidth,
        error: !!(fieldState.invalid && errText || restProps.multiline && (value === null || value === void 0 ? void 0 : value.length) > charCount),
        children: /*#__PURE__*/ _jsxs(Grid, {
            container: true,
            direction: isHorizontalLayout ? 'row' : 'column',
            rowGap: 0.5,
            children: [
                customLabel && label ? /*#__PURE__*/ _jsx(Grid, {
                    item: isHorizontalLayout,
                    xs: customFieldLayout.mode === CustomFieldLayoutType.horizontal ? (_customFieldLayout_labelCol = customFieldLayout.labelCol) !== null && _customFieldLayout_labelCol !== void 0 ? _customFieldLayout_labelCol : defaultCustomFieldHorizontalLayout.labelCol : undefined,
                    children: /*#__PURE__*/ _jsx(FormLabel, {
                        sx: InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.sx,
                        htmlFor: name,
                        children: label
                    })
                }) : null,
                /*#__PURE__*/ _jsx(Grid, {
                    item: isHorizontalLayout,
                    xs: customFieldLayout.mode === CustomFieldLayoutType.horizontal ? (_customFieldLayout_inputCol = customFieldLayout.inputCol) !== null && _customFieldLayout_inputCol !== void 0 ? _customFieldLayout_inputCol : defaultCustomFieldHorizontalLayout.inputCol : undefined,
                    children: /*#__PURE__*/ _jsx(Tooltip, {
                        title: isTooltipVisible ? value : '',
                        children: /*#__PURE__*/ _jsx(TextField, _object_spread_props(_object_spread({
                            id: name,
                            fullWidth: fullWidth
                        }, restProps, restField), {
                            label: !customLabel ? label : '',
                            value: (_ref = displayValue !== null && displayValue !== void 0 ? displayValue : value) !== null && _ref !== void 0 ? _ref : '',
                            onChange: handleChange,
                            onBlur: handleBlur,
                            InputProps: _object_spread({
                                readOnly: disabled,
                                'aria-disabled': disabled
                            }, restProps.InputProps),
                            InputLabelProps: _object_spread_props(_object_spread({}, InputLabelProps), {
                                shrink: (InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.shrink) === false ? undefined : true
                            }),
                            error: !!(fieldState.invalid && errText || restProps.multiline && (value === null || value === void 0 ? void 0 : value.length) > charCount),
                            helperText: errText !== null && errText !== void 0 ? errText : helperText,
                            inputRef: function(input) {
                                inputTextRef.current = input;
                                ref(input);
                            },
                            onWheelCapture: handleWheel
                        }))
                    })
                })
            ]
        })
    });
};
